import ReactDOM from "react-dom";
import React from "react";
import SwiperCore, {
    Navigation,
    Pagination,
} from "swiper/core";
import "swiper/swiper.min.css";
import "swiper/components/zoom/zoom.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/pagination/pagination.min.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./assets/fonts/font.css";
import "./assets/styles/App.scss";
import "../node_modules/video-react/dist/video-react.css"; // import css
import Board from "./components/Board"
import BoardSelector from "./components/BoardSelector";

SwiperCore.use([Pagination, Navigation]);

ReactDOM.render(
    <BrowserRouter basename="/">
        <React.StrictMode>
            <Routes>
                <Route path="/" element={<Navigate replace to='/presentations' />} />
                <Route path="/presentations/:boardId" element={<Board />} />
                <Route path="/presentations" element={<BoardSelector />} />
            </Routes>
        </React.StrictMode>
    </BrowserRouter>,
    document.getElementById("root")
);
